class Auth {
  constructor() {
    // Try to initialize immediately
    this.initialize();
    
    // Also try again after a short delay to ensure DOM is fully loaded
    setTimeout(() => {
      if (!this.isInitialized) {
        this.initialize();
      }
    }, 500);
  }

  initialize() {
    this.loginButton = document.querySelector('.button-login');
    this.registerButton = document.querySelector('.button-register');
    this.loginForm = document.querySelector('.login-form');
    this.registerForm = document.querySelector('.register-form');
    this.accountButton = document.querySelector('.account-button');
    this.modal = document.querySelector('.auth-modal');

    if (this.loginButton && this.registerButton && this.loginForm && this.registerForm && this.accountButton && this.modal) {
      this.initializeEventListeners();
      this.isInitialized = true;
    }
  }

  initializeEventListeners() {
    // Modal handling
    this.accountButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.openModal();
    });
    
    // Close modal when clicking outside
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // Form switching
    this.loginButton.addEventListener('click', () => this.switchToLogin());
    this.registerButton.addEventListener('click', () => this.switchToRegister());

    // Handle escape key to close modal
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.modal.classList.contains('hidden')) {
        this.closeModal();
      }
    });
  }

  openModal() {
    this.modal.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
    this.switchToLogin(); // Always start with login form
  }

  closeModal() {
    this.modal.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }

  switchToLogin() {
    this.loginButton.classList.add('bg-black', 'text-white');
    this.registerButton.classList.remove('bg-black', 'text-white');
    this.loginForm.classList.remove('hidden');
    this.registerForm.classList.add('hidden');
  }

  switchToRegister() {
    this.registerButton.classList.add('bg-black', 'text-white');
    this.loginButton.classList.remove('bg-black', 'text-white');
    this.registerForm.classList.remove('hidden');
    this.loginForm.classList.add('hidden');
  }
}

// Initialize auth when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.authInstance = new Auth();
});

// Also try to initialize when the window is fully loaded
window.addEventListener('load', () => {
  if (!window.authInstance || !window.authInstance.isInitialized) {
    window.authInstance = new Auth();
  }
}); 